const focus = {
  mounted: (el) => el.focus()
};

export default {
  directives: {
    // enables v-focus in template
    focus
  }
};
